import { AfterViewInit, Component, OnDestroy, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { UpNextHeroCardComponent } from '../../../courses/components/cards/up-next-hero-card/up-next-hero-card.component';
import { ProgramTileCardComponent } from '../../../courses/components/cards/program-tile-card/program-tile-card.component';
import { GamificationBootstrap, GamificationAchievement } from '../../../gamification/models/gamification-bootstrap.model';

// Isolated, synthetic fixture: no student records, quiz results, or enrolments are written.
@Component({
  selector: 'app-break-ui-homepage',
  templateUrl: './break-ui-homepage.component.html',
  styleUrls: ['../main-dashboard-redesign/main-dashboard-redesign.component.scss', './break-ui-homepage.component.scss']
})
export class BreakUiHomepageComponent implements AfterViewInit, OnDestroy {
  @ViewChild(UpNextHeroCardComponent) hero: UpNextHeroCardComponent;
  @ViewChildren(ProgramTileCardComponent) cards: QueryList<ProgramTileCardComponent>;
  readonly enabled = !environment.production && ['localhost', '127.0.0.1'].includes(location.hostname);
  readonly states = ['demo', 'worst', 'empty', 'one', 'huge'];
  state = 'demo';
  firstName = 'Dante';
  today = new Date();
  bootstrap: GamificationBootstrap;
  achievements: GamificationAchievement[] = [];
  courses: any[] = [];
  lesson: any;
  constructor() {
    const requested = new URLSearchParams(location.search).get('data');
    this.selectState(this.states.includes(requested) ? requested : 'demo');
  }
  private readonly guardAction = (event: MouseEvent): void => {
    const target = event.target as HTMLElement;
    if (!target.closest('.fixture-toggle')) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  };
  ngAfterViewInit(): void {
    document.querySelector('app-break-ui-homepage').addEventListener('click', this.guardAction, true);
    this.cards.changes.subscribe(() => this.configureCards());
    setTimeout(() => this.configureCards());
  }
  ngOnDestroy(): void {
    document.querySelector('app-break-ui-homepage')?.removeEventListener('click', this.guardAction, true);
  }
  selectState(state: string): void {
    this.state = state;
    const worst = state === 'worst' || state === 'huge';
    const count = state === 'empty' ? 0 : state === 'one' ? 1 : state === 'huge' ? 1000 : 3;
    this.firstName = worst ? 'Aleksandra Wiśniewska-Kowalczyk' : state === 'one' ? 'J' : state === 'empty' ? 'Future Pilot' : 'Dante';
    this.achievements = Array.from({length: count}, (_, i) => ({
      StudentAchievementId: i + 1, AchievementDefinitionId: i + 1, AchievementKey: 'fixture-' + i,
      Name: worst ? ['Private Pilot Airplane — High Performance and Complex Aircraft Endorsement', 'Benachrichtigungseinstellungen', '王秀英 — Đặng Thị Ngọc Hân 👩🏽‍💻'][i % 3] : ['Private Pilot Airplane', 'Study Streak', 'Greased Landing'][i % 3],
      Description: '', ScopeType: 'global', IconCssClass: i === 2 ? '' : 'fa fa-trophy', DisplayOrder: i,
      CurrentMetricValue: worst ? 1284 : state === 'one' ? 1 : i === 0 ? 26 : 0,
      NextAchievementTierId: i + 1, NextThreshold: worst ? 10000 : 50, ProgressPercent: worst ? 142 : 52,
      Mastered: false, Tiers: [{AchievementTierId: i + 1, TierOrder: 1, TierKey: 'gold', MetricTypeId: 1,
        Threshold: worst ? 10000 : 50, RequirementText: '', Earned: false}]
    }));
    this.bootstrap = {
      IsAvailable: true, CurrentWeek: [], Achievements: this.achievements, ClosestAchievements: this.achievements,
      Summary: {IsAvailable: true, CurrentProtectedStreakDays: worst ? 1284 : state === 'one' ? 1 : 0,
        LongestProtectedStreakDays: worst ? 1284 : 1, WeatherDayBalance: 2},
      DailyQuiz: {IsSuccess: true, IsAvailable: state !== 'empty', QuestionCount: state === 'one' ? 1 : 5,
        CourseName: worst ? 'AircraftElectricalSystemsTroubleshooting' : null} as any
    };
    this.lesson = {CourseLessonId: -1, CourseModuleId: -1, CourseModuleCourseId: -1,
      LessonOrder: state === 'one' ? 1 : 21,
      LessonName: worst ? 'Emergency Procedures and Abnormal Operations — Electrical System Failures, Smoke and Fire During Instrument Meteorological Conditions' : '7.21 Module Final',
      CourseModuleIdDisplay: worst ? 'AircraftElectricalSystemsTroubleshooting' : 'Module 7 - Aircraft Systems',
      CourseName: worst ? 'Private Pilot Airplane — High Performance and Complex Aircraft Endorsement' : 'Private Pilot Airplane',
      CourseLessonProgressPercentComplete: worst ? 142 : 25};
    this.courses = Array.from({length: count}, (_, i) => ({CourseId: -i - 1,
      CourseName: worst ? ['Private Pilot Airplane — High Performance and Complex Aircraft Endorsement', 'AircraftElectricalSystemsTroubleshooting', '', '王秀英 — Đặng Thị Ngọc Hân 👩🏽‍💻'][i % 4] : i ? 'Multi-Engine Course' : 'Private Pilot Airplane',
      StudentCoursePercentComplete: worst ? [142, -3, 0][i % 3] : 25,
      StudentCourseModulesCompleted: worst ? 1284 : state === 'one' ? undefined : 6,
      StudentCourseModulesCount: worst ? 1285 : state === 'one' ? 1 : 23,
      MediaMediaPath: ''}));
    const url = new URL(location.href); url.searchParams.set('data', state); history.replaceState(null, '', url.toString());
    setTimeout(() => this.configureCards());
  }
  private configureCards(): void {
    if (this.hero) {
      this.hero.data = this.lesson;
      this.hero.setupCard();
      this.hero.defaultImageUrl = this.hero.defaultImageUrl || '/assets/aviator-online/img/lesson-image-default.png';
      this.hero.imageUrl = this.state === 'worst' ? '/assets/break-ui-missing.test.png' : this.hero.imageUrls.mainImageUrl;
    }
    this.cards?.forEach((card, i) => {
      card.data = this.courses[i];
      card.setupCard();
      if (this.state === 'worst' && i === 0) card.courseImageUrl = '/assets/break-ui-missing.test.png';
    });
  }
}
